<script setup lang="ts">
import {ref, watch} from 'vue';
import {useRoute, useRouter} from 'vue-router';
import {ElButton} from 'element-plus';
import {OverallPage} from 'common';
import {dashboardOverall} from '@/base/callBackend.js';
import {dashboardOrgs, dashboardPeriod, laadDashboard} from '@/base/dashboardState.js';
import KpiCard from '@/views/dashboard/KpiCard.vue';
import StatusBar from '@/views/dashboard/StatusBar.vue';
import StatusMatrix from '@/views/dashboard/StatusMatrix.vue';

const route   = useRoute();
const router  = useRouter();
const loading = ref<boolean>(true);
const page    = ref<OverallPage | undefined>(undefined);
let loadSeq: number = 0;
// the landing this dashboard is mounted under (/admin/dashboard, /report/dashboard or /dashboard), from the route meta set in dashboardRoute()
const base: string = route.matched.find(r => r.meta.base)?.meta.base as string;

watch([dashboardPeriod, dashboardOrgs], load, {immediate: true});

async function load() {
    if (dashboardPeriod.value === '') {
        return;
    }
    const seq: number                     = ++loadSeq;
    loading.value                         = true;
    const result: OverallPage | undefined = await laadDashboard(() => dashboardOverall(dashboardPeriod.value, dashboardOrgs.value));
    if (seq !== loadSeq) {
        return;
    }
    page.value    = result;
    loading.value = false;
}
</script>

<template>
    <div class="px-10 py-4 flex flex-col gap-8">
        <div v-if="loading" class="text-sm text-gray-500">laden...</div>
        <template v-else-if="page">
            <div class="flex flex-row flex-wrap gap-4">
                <KpiCard v-for="k in page.kaarten" :key="k.label" data-testid="overall-card" :label="k.label" :value="k.waarde"/>
            </div>

            <section class="flex flex-col gap-2">
                <div class="text-xl font-semibold text-zzc-blue">FTE-impact t.o.v. target</div>
                <StatusBar v-for="b in page.balken" :key="b.label" :balk="b"/>
            </section>

            <StatusMatrix :matrix="page.matrix" titel="Samenvatting transformatiedashboard"/>
            <div class="text-sm text-gray-500">Status per organisatie voor de geselecteerde rapportageperiode.</div>

            <div>
                <el-button type="primary" @click="router.push(`${base}/initiatieven`)">Bekijk initiatieven</el-button>
            </div>
        </template>
        <div v-else class="text-sm text-gray-500">Geen gegevens (laden mislukt).</div>
    </div>
</template>
